module.exports = "";


//////////////////
// WEBPACK FOOTER
// ./src/components/notification/notification.html
// module id = 782
// module chunks = 0